var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.738 269.917c21.981 21.981 45.508 44.68 76.44 61.208a35.79 35.79 0 0041.66-5.564 62.194 62.194 0 018.706-6.725 40.792 40.792 0 0138.615-2.943c20.863 9.292 40.434 21.164 58.393 36.258a40.756 40.756 0 0111.404 47.293c-9.717 22.937-23.013 44.801-39.642 65.667a40.762 40.762 0 01-46.541 12.769c-84.247-32.661-154.757-84.658-214.375-144.276C118.937 274.143 66.36 201.715 34.188 119.26A40.746 40.746 0 0146.93 72.67c20.843-16.63 42.698-29.917 65.627-39.618a40.743 40.743 0 0147.279 11.399c15.296 18.181 27.278 38.022 36.589 59.197a40.759 40.759 0 01-.947 34.864c-2.608 5.284-5.166 9.521-8.852 13.754a35.861 35.861 0 00-4.688 40.393c16.287 30.905 38.483 53.94 61.8 77.258z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSimple);
export default __webpack_public_path__ + "static/media/phone-simple.88c326e86ffb192b990e968c5f9eb045.svg";
export { ForwardRef as ReactComponent };